import {
	setAlert,setAlertNextPage
} from 'helpers/alertHelpers';
import { addPaymentInfo } from 'helpers/dataLayerHelpers';
import {
	postCheckout, stripeTokenSave
} from 'helpers/paymentHelpers';
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge'
import React , { Component } from 'react';
import {
	injectStripe, PaymentRequestButtonElement
} from 'react-stripe-elements';
import styled from 'styled-components';

const LABEL_TEXT = 'Apostrophe Dermatology Purchase'

const Wrapper = styled.div`
  background-color: 'black';
  ${props => ( props.medCheckout || props.useUpdatedRegistration ) && 'border: 1px solid #d9d9d9; borderRadius: 2px;'}
`;

class PaymentRequest extends Component {
	constructor(props) {
		super(props)
		const paymentRequest = props.stripe.paymentRequest({
			country: 'US',
			currency: 'usd',
			total: {
				label: LABEL_TEXT,
				amount: this.props.cart ? this.props.cart.cartTotalCents : 0,
			},
		})
		this.setCurrentTotal = this.setCurrentTotal.bind(this)

		const {
			setBodyBusy, openCrossSell,
		} = this.props;
		paymentRequest.on('token',
			async ({
				complete, token, ...data
			}) => {
				try {
					setBodyBusy(true)
					let data = {
						...props,
						token,
					}
					console.log(data)
					const saved = await stripeTokenSave(data)
					if (!isEmpty(saved)) {
						if (saved.success) {
							if (props.saveOnly) {
								complete('success')
								props.propogatePaymentInfo(saved.response.existing_payments)
								setBodyBusy(false)
								setAlert('success',
									'Successfully updated payment information')
							} else {
								const data = merge(props,
									{ paymentMethod: 'stripe' })
								const paid = await postCheckout(data,
									'browserPay')
								if (paid.success) {
									setAlertNextPage('success',
										paid.successMessage)
									const {
										response, nextStep,
									} = paid;
									complete('success');
									if (response.cross_sell) {
										setBodyBusy(false);
										openCrossSell(nextStep,
											response.cross_sell);
									} else {
										window.location = nextStep;
									}
								} else {
									console.log('not paid success?',
										paid)
									complete('fail')
									setBodyBusy(false)
								}
							}
						} else {
							console.log('not saved success??',
								saved)
							complete('fail')
							setBodyBusy(false)
						}
					}
				} catch (e) {
					console.log('logging error',
						e)
					complete('fail')
					setBodyBusy(false)
				}
			});

		paymentRequest.canMakePayment().then((result) => {
			this.setState({ canMakePayment: !!result });
			if (this.props.report) {
				this.props.report(this.props.reportProperty,
					!!result)
			}
		});

		this.state = {
			canMakePayment: false,
			paymentRequest,
			cartTotalCents: this.props.cart ? this.props.cart.cartTotalCents : 0,
		};

	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const { cartTotalCents } = nextProps.cart
		if (cartTotalCents == prevState.cartTotalCents) {
			// Return null to indicate no change to state.
			return null;
		}
		return {
			...prevState,
			cartTotalCents,
		}

		// Return null to indicate no change to state.
		return null;
	}

	setCurrentTotal(){
		const {
			cartTotalCents, paymentRequest,
		} = this.state;
		paymentRequest.update({
			total: {
				amount: cartTotalCents,
				label: LABEL_TEXT,
			},
		})
		this.setState({
			paymentRequest,
		})
	}

	render() {
		return this.state.canMakePayment ? (
			<Wrapper medCheckout={this.props.medCheckout} onClick={() => addPaymentInfo('Browser Payment')}>
				<PaymentRequestButtonElement
					onClick={this.setCurrentTotal}
					paymentRequest={this.state.paymentRequest}

					style={{
						// For more details on how to style the Payment Request Button, see:
						// https://stripe.com/docs/elements/payment-request-button#styling-the-element
						paymentRequestButton: {
							theme: this.props.darkMode ? 'dark' : 'light',
							height: '64px',
						},
					}}
				/>
			</Wrapper>
		) : null;
	}
}

export default injectStripe(PaymentRequest)
